import React from 'react'
import { buttonVariants } from './shadcn/Button'

type Props = {
  url: string
  children: React.ReactNode
}

export const LinkExternal: React.FC<Props> = ({ url, children }) => {
  const desktopApp: any = window._depoto
  return desktopApp ? (
    <a href="#" onClick={() => desktopApp.nw.openLinkInDefaultBrowser(url)}>
      {children}
    </a>
  ) : (
    <a href={url} target="_blank">
      {children}
    </a>
  )
}
